import React, { useMemo, useState } from 'react';
import { BroadcastNotificationDetail } from '../../../../model/notifications/notifications';
import styles from './PopupNotification.module.scss';
import { ChevronRightIcon } from '../../../../assets/icons';

interface PopupNotificationProps {
    notifications: BroadcastNotificationDetail[];
    onClose: () => void;
}

const PopupNotification: React.FC<PopupNotificationProps> = ({ notifications, onClose }) => {
    const items = useMemo(
        () => notifications.filter(n => n.turnOnOff !== false),
        [notifications],
    );
    const [index, setIndex] = useState(0);

    if (items.length === 0) return null;

    const current = items[index];
    const hasButton = current.addButton && !!current.buttonLabel;

    const goPrev = () => setIndex(i => Math.max(0, i - 1));
    const goNext = () => setIndex(i => Math.min(items.length - 1, i + 1));

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={e => e.stopPropagation()}>
                <div className={styles.header}>
                    <span className={styles.badge}>What's New</span>
                    <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
                        ✕
                    </button>
                </div>

                {current.title && <h2 className={styles.title}>{current.title}</h2>}

                {current.image && <img className={styles.image} src={current.image} alt={current.title ?? ''} />}

                {current.message && <p className={styles.message}>{current.message}</p>}

                {hasButton && (
                    <button
                        type="button"
                        className={styles.ctaButton}
                        onClick={() => {
                            if (current.buttonLinkScreen) window.location.href = current.buttonLinkScreen;
                        }}
                    >
                        {current.buttonLabel}
                    </button>
                )}

                {items.length > 1 && (
                    <div className={styles.footer}>
                        <button
                            type="button"
                            className={styles.navButton}
                            onClick={goPrev}
                            disabled={index === 0}
                            aria-label="Previous"
                        >
                            <ChevronRightIcon className={styles.navIconLeft} />
                        </button>

                        <div className={styles.dots}>
                            {items.map((_, i) => (
                                <span key={i} className={`${styles.dot} ${i === index ? styles.dotActive : ''}`} />
                            ))}
                        </div>

                        <button
                            type="button"
                            className={styles.navButton}
                            onClick={goNext}
                            disabled={index === items.length - 1}
                            aria-label="Next"
                        >
                            <ChevronRightIcon className={styles.navIcon} />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PopupNotification;
